/**
 * Manages the error message that appears on the map
 * @param map
 */
define(['jquery'], function ($) {
   "use strict";

   return function (map) {
      var self = this,
         m_map = map,
         m_jLabel = $("#heatMapLabel"),
         m_iMinZoom = 10,
         m_tools = {},
         m_aEnabled = [],
         m_iZoom = 0,

         showMessage = function (strMessage) {
            m_jLabel.html(strMessage + "<br/>Please zoom in to see updated tools.").show();
         },

         showSpecificMessage = function () {
            var strTool = m_aEnabled[0],
               strMessage = m_tools[strTool];

            showMessage(strMessage);
         },

         getToolIndex = function (strTool) {
            var iPosition = $.inArray(strTool, m_aEnabled);
            return iPosition;
         },

         isToolEnabled = function (strTool) {
            return (getToolIndex(strTool) !== -1);
         },

         disable = function (strTool) {
            var iPosition = getToolIndex(strTool);
            if (iPosition > -1) {
               m_aEnabled.splice(iPosition, 1);
            }
         },

         showGenericMessage = function () {
            showMessage("Map features you requested are not available at this zoom level.");
         },

         hideMessage = function () {
            m_jLabel.hide();
         },

         inRange = function () {
            return (m_iZoom > m_iMinZoom);
         },

         onChange = function () {
            // If we are within zoom range, or no items are enabled
            if (m_aEnabled.length === 0) {
               hideMessage();
            } else if (m_aEnabled.length === 1) {
               showSpecificMessage();
            } else {
               showGenericMessage();
            }
         },

         initialize = function () {};

      self.inRange = inRange;

      self.refresh = function () {
         m_iZoom = m_map.getZoom();
         onChange();
      };

      self.addTool = function (strTool, strMessage) {
         m_tools[strTool] = strMessage;
      };

      self.enable = function (strTool) {
         if (isToolEnabled(strTool)) {
            return;
         }
         m_aEnabled.push(strTool);
         onChange();
      };

      self.enableTemporarily = function (strTool) {
         m_jLabel.css({
            backgroundColor: '#fff',
            color: 'black'
         }).animate({
            backgroundColor: 'black',
            color: 'white'
         }, {
            easing: 'easeInQuad',
            duration: 500
         });

         self.enable(strTool);
         disable(strTool);
      };

      self.disable = function (strTool) {
         disable(strTool);
         onChange();
      };

      initialize();
   };
});
